import { ValidationResult } from "./validation-result";
import {DwUtils} from "../components/utils/dw-utils";

export interface HouseholdMember {
  id: number;
  caseId: number;
  memberId: number
  flatRequestId: number | null;
  flatHouseholdMembersId: number;
  firstName: string;
  middleName: string;
  lastName: string;
  gender: string;
  dateOfBirth: string;
  memberComments: string;
  duplicateKey:string;
  isSelected:any;
  
  deletable:Boolean;
  editable: Boolean;
}

export class HouseholdMember {
  constructor() {
    this.id = 0;
    this.caseId = 0;
    this.memberId =0;
    this.flatRequestId = null;
    this.flatHouseholdMembersId = 0;
    this.firstName = '';
    this.middleName = '';
    this.lastName = '';
    this.gender =  '';
    this.dateOfBirth = '';
    this.memberComments = '';
    this.duplicateKey = '';
  }

  public setApplicantRecord(first: string, middle: string, last: string, dob:string, gender:string) {
    this.firstName = DwUtils.capitalize((first || '').trim());
    this.middleName = DwUtils.capitalize((middle || '').trim());
    this.lastName = DwUtils.capitalize((last || '').trim());
    this.dateOfBirth = dob;
    this.gender = gender;
    this.setDuplicateKey();
  }
  public setAdvocateRecord(first: string, middle: string, last: string) {
    this.firstName = DwUtils.capitalize((first || '').trim());
    this.middleName = DwUtils.capitalize((middle || '').trim());
    this.lastName = DwUtils.capitalize((last || '').trim());
    this.dateOfBirth = null;
    this.duplicateKey = '';
  }

  public setDuplicateKey(): string {
    this.duplicateKey =
        DwUtils.createDuplicateKey(this.firstName, this.lastName, this.dateOfBirth, this.gender);
    return this.duplicateKey;
  }
  public validateRecord(relationship: string): ValidationResult {
    const vr: ValidationResult = new ValidationResult();

    // Trim names to remove leading/trailing spaces
    this.firstName = (this.firstName || '').trim();
    this.middleName = (this.middleName || '').trim();
    this.lastName = (this.lastName || '').trim();

    if (!this.firstName || this.firstName.length === 0) {
      vr.focus_field = 'firstName';
      vr.error = 'Error: A first name is required';
      return vr;
    }

    if (!this.lastName || this.lastName.length === 0) {
      vr.focus_field = 'lastName';
      vr.error = 'Error: A last name is required';
      return vr;
    }

    if(this.gender.length === 0) {
      this.gender = 'Unknown';
    }

    /** set the duplicate key value **/
    this.setDuplicateKey();

    if (relationship !== "Advocate") {
      if (DwUtils.chkValidDate(this.dateOfBirth) === false) {
        vr.focus_field = 'dob';
        vr.error = 'Error: Incorrect date format (use YYYY-MM-DD)';
        return vr;
      }

      const errMsg = DwUtils.chkDateOfBirth(this.dateOfBirth);

      if(errMsg.length > 0) {
        vr.focus_field = 'dob';
        vr.error = errMsg;
        return vr;
     }
    }
    else {
      this.dateOfBirth = null;
    }
    // Add more validation rules as needed for other properties

    return vr;
  }
}
